export default __webpack_public_path__ + "static/h2-modal-advent-calendar-6cdfc7cfe12f60729b207d7304db83ed.svg";